/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

module.exports = {
    EVENT_TYPE_LIKE: 'like',
    EVENT_REBATE_CLAIM_OPT_IN: 'rebate_claim_opt_in',
    EVENT_SET_ELECTRICAL_UTILITY: 'set_electrical_utility',
    EVENT_SOLAR_SIGN_UP: 'solar_lead_sign_up',
    SAVED_SEARCH_TYPE_LIKE: 'saved_search',
    REPORTING_FORM: 'reporting-form',
    VERIFICATION_FORM: 'verification-form',
    FORM_COMPLETE: 'formComplete',
    DEMAND_RESPONSE_BUSINESS_CODE: 'DR',
    CLAIM_VALIDATION_BYPASS_CODE: 'claim_validation_bypass_code',
    RESULTS_QUERY_PARAMS: {
        fr_FR: {
            sortByParamName: 'trierPar',
            filtersParamsName: 'filtres',
            resultsParams: '&filtres'
        },
        en_EN: {
            sortByParamName: 'sortBy',
            filtersParamsName: 'filters',
            guideParamsName: 'guide',
            resultsParams: '&filters&guide'
        },
    },
};
